/**
 *
 * @param {Object} state
 * @param {String} productId
 */
const SET_PREPREND_CART_PRODUCT_ID = (state, productId) => {
  productId != "" ? (state.preprendCartData.product = productId) : false;
};
/**
 *
 * @param {Object} state
 * @param {String} relatedProduct
 */
const SET_PREPREND_CART_RELATED_PRODUCT = (state, relatedProduct) => {
    (relatedProduct != "") ? (state.preprendCartData.related_product = relatedProduct) : state.preprendCartData.related_product = false;
};

/**
 * @param {Object} state
 * @param {String} postalCode
 */
const SET_PREPREND_CART_INTERVENTION_POSTAL_CODE = (state, postalCode) => {
  postalCode ? (state.preprendCartData.mcp_intervention_zipcode = postalCode) : false;
};

/**
 * @param {Object} state
 * @param {String} agenceId
 */
const SET_PREPREND_CART_INTERVENTION_AGENCE_ID = (state, agenceId) => {
  agenceId ? (state.preprendCartData.mcp_agency = agenceId) : false;
};
/**
 * @param {Object} state
 * @param {String} currentSelectedDelivery
 */
const SET_PREPREND_CART_CURRENT_SELECTED_DELIVERY = (state, currentSelectedDelivery) => {
  currentSelectedDelivery ? (state.currentSelectedDelivery = currentSelectedDelivery) : false;
};

/**
 * @param {Object} state
 * @param {String} slotId
 */
const SET_PREPREND_CART_INTERVENTION_SLOT = (state, slotId) => {
  slotId ? (state.preprendCartData.mcp_intervention_slot = slotId) : false;
};

/**
 * @param {Object} state
 * @param {Boolean} fakeSlot
 */
const SET_PREPREND_CART_INTERVENTION_FAKE_SLOT = (state, fakeSlot) => {
  fakeSlot ? (state.preprendCartData.mcp_intervention_fake_slot = fakeSlot) : false;
};

/**
 * @param {Object} state
 * @param {String} startDate
 */
const SET_PREPREND_CART_INTERVENTION_DATE = (state, startDate) => {
  startDate
    ? (state.preprendCartData.mcp_intervention_date = startDate.toISOString().slice(0, 10))
    : false;
};

/**
 * @param {Object} state
 * @param {String} additionalSku
 */
const SET_PREPREND_CART_INTERVENTION_ADDITIONAL_SKU = (state, additionalSku) => {
  additionalSku ? (state.preprendCartData.mcp_additional_sku = additionalSku) : false;
};

/**
 * @param {Object} state
 * @param {String} interventionProductId
 */
const SET_PREPREND_CART_INTERVENTION_PRODUCT = (state, interventionProductId) => {
  interventionProductId
    ? (state.preprendCartData.mcp_intervention_product = interventionProductId)
    : false;
};

/**
 * @param {Object} state
 * @param {Object} interventionProductId
 */
const SET_PREPREND_CART_REDUCED_TAX_RATE = (state, reducedTaxRate) => {
  reducedTaxRate ? (state.preprendCartData.reduced_tax_rate = reducedTaxRate) : false;
};
/**
 * @param {Object} state
 * @param {Boolean} needCartCleaning
 */
const SET_PREPREND_CART_NEED_CART_CLEANING = (state, needCartCleaning) => {
  typeof needCartCleaning !== "undefined"
    ? (state.preprendCartData.need_cart_cleaning = needCartCleaning)
    : false;
};
/**
 * @param {Object} state
 * @param {Boolean} standardDeliveryInCart
 */
const SET_PREPREND_CART_STANDARD_DELIVERY_IN_CART = (state, standardDeliveryInCart) => {
  typeof standardDeliveryInCart !== "undefined"
    ? (state.preprendCartData.standard_delivery_in_cart = standardDeliveryInCart)
    : false;
};
/**
 * @param {Object} state
 * @param {Boolean} installationProductInCart
 */
const SET_PREPREND_CART_INSTALLATION_PRODUCT_IN_CART = (state, installationProductInCart) => {
  typeof installationProductInCart !== "undefined"
    ? (state.preprendCartData.installation_product_in_cart = installationProductInCart)
    : false;
};
/**
 * @param {Object} state
 * @param {Boolean} deliveryOnly
 */
const SET_PREPREND_CART_DELIVERY_ONLY = (state, deliveryOnly) => {
  typeof deliveryOnly !== "undefined"
    ? (state.preprendCartData.delivery_only = deliveryOnly)
    : false;
};
/**
 * @param {Object} state
 * @param {Boolean} isExclusive
 */
const SET_PREPREND_CART_IS_EXCLUSIVE = (state, isExlusive) => {
  typeof isExlusive !== "undefined" ? (state.preprendCartData.is_exclusive = isExlusive) : false;
};
/**
 * @param {Object} state
 * @param {Boolean} isExclusive
 */
const SET_PREPREND_CART_QUANTITY = (state, quantity) => {
  quantity > 0 ? (state.preprendCartData.qty = quantity) : false;
};
/**
 * @param {Object} state
 * @param {Boolean} taxProfile
 */
const SET_TAX_PROFILE = (state, taxProfile) => {
  taxProfile ? (state.tax_profile = taxProfile) : false;
};
/**
 * @param {Object} state
 * @param {Number} additionalInfo
 */
const SET_PREPREND_CART_ADDITIONAL_INFO = (state, additionalInfo) => {
  typeof additionalInfo !== "undefined" ? (state.additionalInfo = additionalInfo) : 0;
};

/**
 * @param {Object} state
 */
const EMPTY_PREPREND_CART_REDUCED_TAX_RATE = state => {
  delete state.preprendCartData.reduced_tax_rate;
};
/**
 * @param {Object} state
 * @param {Boolean} isExclusive
 */
const SET_PREPREND_CART_IS_RENTING = (state, isRenting) => {
    state.preprendCartData.is_renting = isRenting;
};
/**
 * @param {Object} state
 * @param {Boolean} isFinancing
 */
 const SET_PREPREND_CART_IS_FINANCING = (state, isFinancing) => {
  state.preprendCartData.is_financing = isFinancing;
};

/**
 * @param {Object} state
 * @param {Boolean} isExclusive
 */
const SET_PREPREND_CART_NB_MONTHS = (state, nbMonths) => {
    state.preprendCartData.nb_months = nbMonths;
};
/**
 * @param {Object} state
 * @param {Boolean} isExclusive
 */
const SET_PREPREND_CART_FINANCING_NB_MONTHS = (state, nbMonths) => {
    state.preprendCartData.nb_months_financing = nbMonths;
};

export default {
  SET_PREPREND_CART_PRODUCT_ID,
  SET_PREPREND_CART_RELATED_PRODUCT,
  SET_PREPREND_CART_INTERVENTION_SLOT,
  SET_PREPREND_CART_INTERVENTION_FAKE_SLOT,
  SET_PREPREND_CART_INTERVENTION_POSTAL_CODE,
  SET_PREPREND_CART_CURRENT_SELECTED_DELIVERY,
  SET_PREPREND_CART_INTERVENTION_ADDITIONAL_SKU,
  SET_PREPREND_CART_INTERVENTION_AGENCE_ID,
  SET_PREPREND_CART_INTERVENTION_DATE,
  SET_PREPREND_CART_INTERVENTION_PRODUCT,
  SET_PREPREND_CART_REDUCED_TAX_RATE,
  EMPTY_PREPREND_CART_REDUCED_TAX_RATE,
  SET_PREPREND_CART_NEED_CART_CLEANING,
  SET_TAX_PROFILE,
  SET_PREPREND_CART_STANDARD_DELIVERY_IN_CART,
  SET_PREPREND_CART_INSTALLATION_PRODUCT_IN_CART,
  SET_PREPREND_CART_DELIVERY_ONLY,
  SET_PREPREND_CART_IS_EXCLUSIVE,
  SET_PREPREND_CART_QUANTITY,
  SET_PREPREND_CART_ADDITIONAL_INFO,
  SET_PREPREND_CART_IS_RENTING,
  SET_PREPREND_CART_IS_FINANCING,
  SET_PREPREND_CART_NB_MONTHS,
  SET_PREPREND_CART_FINANCING_NB_MONTHS,
};
